import { render, staticRenderFns } from "./FintechSortAsc.vue?vue&type=template&id=79a0a8e5&"
import script from "./FintechSortAsc.vue?vue&type=script&lang=js&"
export * from "./FintechSortAsc.vue?vue&type=script&lang=js&"
import style0 from "./FintechSortAsc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports